import styled from '@emotion/styled';
import { FC, PropsWithChildren } from 'react';

// Local Typings
interface StaticProps {
  fullWidth?: boolean;
  isIn?: boolean;
  position?: 'absolute' | 'fixed' | 'relative';
  transitionSpeedInMs: number;
  zIndex?: number;
}
interface XProps {
  endX: number | string;
  endY?: never;
  startX: number | string;
  startY?: never;
}
interface YProps {
  endX?: never;
  endY: number | string;
  startX?: never;
  startY: number | string;
}
interface XYProps {
  endX: number | string;
  endY: number | string;
  startX: number | string;
  startY: number | string;
}

type Props = StaticProps & (XProps | XYProps | YProps);

// Local Variables
const slideClassName = 'slide-is-in';
const getValue = (value?: number | string): string => {
  if (value === undefined) {
    return '0';
  }

  return typeof value === 'number' ? `${value}px` : value;
};

const Wrapper = styled.div<Props>(props => {
  return ({
    [`&.${slideClassName}`]: {
      transform: `translate(${getValue(props.endX)}, ${getValue(props.endY)})`,
    },
    position: props.position,
    transform: `translate(${getValue(props.startX)}, ${getValue(props.startY)})`,
    transition: `transform ${props.transitionSpeedInMs}ms`,
    width: props.fullWidth ? '100%' : 'auto',
    zIndex: props.zIndex,
  });
});

// Component Definition
const Slide: FC<PropsWithChildren<Props>> = ({
  children,
  isIn = true,
  position = 'absolute',
  ...props
}) => (
  <Wrapper
    className={isIn ? slideClassName : undefined}
    position={position}
    {...props}
  >
    {children}
  </Wrapper>
);

export default Slide;
